module.exports = __webpack_public_path__ + "media/images/partner-8-df4069f5c1d2f4e1f5e22367c257a2ac.png";